package ru.chm.gradereport.ui.screens.course

fun trimScore(value: Double): String =
    if (value == value.toLong().toDouble()) value.toLong().toString() else value.toString()
